@if (links) {
    @for (link of links; track link; let i = $index) {
        @if (computedFields[i].visible !== undefined ? computedFields[i].visible : true) {
            @if (computedFields[i].disabled || link.disabled || !(computedFields[i].url || link.url)) {
                <span>{{ link.text | translate }}</span>
            } @else {
                <a class="listingsTableLink" [appRouterLinkEnhanced]="computedFields[i].url || link.url"> {{ link.text | translate }}</a>
            }
        }
    }
}
